module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-15.a8c974c2.png";